export const ROUTES_DEFINITIONS = {
    Dashboard:'/',
    Login:'/login',
    RequestPassword:'/request-password',
    RestPassword:'/reset-password/:token',
    Merchants: '/merchants',
    MerchantOrders:'/merchant-orders',
    Products:'/products',
    Categories:'/categories',
    Orders:'/orders',
    HelpDesk:'/help',
    Settings:'/settings',
    Reset:'reset'
}
